import { render, staticRenderFns } from "./CreditItems.vue?vue&type=template&id=0d068ee3"
import script from "./CreditItems.vue?vue&type=script&lang=js"
export * from "./CreditItems.vue?vue&type=script&lang=js"
import style0 from "./CreditItems.vue?vue&type=style&index=0&id=0d068ee3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports